module.exports = __webpack_public_path__ + "img/happytable_product4.0e0daaf9.jpg";